import PageContainer from '@zenbusiness/zui/PageContainer';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'ZuiPageContainer',
  slot: 'Root',
  tag: PageContainer,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBlock: 0,

    [theme.breakpoints.up('md')]: {
      marginBlock: 0,
    },

    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(4),
      marginBlock: 0,
    },
  }),
});
